<template>
    <div>
        <div class="plugins-tips">
            <el-select v-model="query.noticeShow" @change="currentNotice($event)" style="width: 100px; margin-right: 10px;">
                <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
            <el-input v-model="query.noticeSearch" placeholder="Filter" @keyup.enter.native="handleNoticeSearch" class="handle-input mr10"></el-input>
            <el-button type="primary" icon="el-icon-search" @click="handleNoticeSearch">搜索</el-button>
            <span style="margin-left: 20px; color: #67C23A; font-size: 15px">查询条件："ID, 编辑者ID"</span> 

            <el-button type="primary" icon="el-icon-circle-plus-outline" @click="postNotice()" style="float: right; margin-right: 20px">新增</el-button>
        </div>
        <el-table
            :data="notice.tableData"
            :header-cell-style="{'text-align':'center'}"
            :cell-style="tableCellStyle"
            @row-click="rowNoticeClick"
            v-loading="notice.loading"
            stripe
        >
            <el-table-column prop="id" label="ID" align="center"></el-table-column>
            <el-table-column prop="creatorId" label="编辑者ID" align="center"></el-table-column>
            <el-table-column prop="title" label="标题" align="center"></el-table-column>
            <el-table-column label="内容" align="center">
                <template slot-scope="scope">
                    <p class="cont">{{ scope.row.content }}</p>
                </template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" :formatter="dateFormat" align="center"></el-table-column>
            <el-table-column prop="noticeShow" label="是否显示" align="center">
                <template slot-scope="scope">
                    <div v-if="scope.row.noticeShow == 0">
                        <el-button type="info" size="mini" @click="changeNoticeShowState(scope.row)">隐藏中</el-button>
                    </div>
                    <div v-if="scope.row.noticeShow == 1">
                        <el-button type="success" size="mini" @click="changeNoticeShowState(scope.row)">显示中</el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination
                background
                layout="total, prev, pager, next"
                :current-page="notice.pageIndex"
                :page-size="notice.pageSize"
                :total="notice.pageTotal"
                @current-change="handleNoticePageChange"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
import { getMarsNotice, updateNoticeShowState} from '../../../api/gameconsole-mars.js'
import moment from 'moment'
export default {
    name: 'MarsNotice',
    data: function(){
        return {
            options: [{
                value: '',
                label: '全部'
            }, {
                value: '0',
                label: '隐藏中'
            }, {
                value: '1',
                label: '显示中'
            }],

            query: {
                noticeShow: '',    // '':全部,  0:隐藏中,  1:显示中
                noticeSearch: '',  // 公告搜索
            },
            //公告
            notice: {
                tableData: [],
                pageIndex: 1,
                pageSize: 9,
                pageTotal: 1,
                loading: true
            },
        }
    },
    created() {
        this.initNoticeData()
    },
    activated() {
        this.initNoticeData()
    },
    methods: {
        //初始化数据
        initNoticeData() {
            this.notice.loading = true
            //如果搜索框不等于 空, 添加搜索条件
            let noticeId = ''
            if (this.query.noticeSearch != '' && this.query.noticeSearch != undefined) {
                noticeId = this.query.noticeSearch
            }

            //发送请求
            let params = {'id': noticeId, 'noticeShow': this.query.noticeShow, 'pageIndex': this.notice.pageIndex, 'pageSize': this.notice.pageSize }
            getMarsNotice(params).then(res => {
                if(res.data.code == 200) {
                    this.notice.tableData = res.data.data.records
                    this.notice.pageTotal = res.data.data.total
                }
                this.notice.loading = false
            }).catch(err => {
                this.notice.loading = false
            })
        },

        //进入新增页
        postNotice(id) {
            localStorage.setItem('noticeId', id)
            setTimeout(() => {
                this.$router.push('/Notice')
            }, 100);
        },

        //是否显示 事件
        changeNoticeShowState(row) {
            // 二次确认
            this.$confirm('确定要变更状态吗？', '提示', {
                type: 'warning'
            }).then(() => {

                //判断 显示状态,  如果为 显示中就隐藏，隐藏中就改为显示，  //noticeShow  0:隐藏 1:显示
                let noticeShow = row.noticeShow
                if (noticeShow == 0) {
                    noticeShow = 1 
                } else {
                    noticeShow = 0
                }
                
                //发送请求
                let params = {'id': row.id, 'noticeShow': noticeShow}
                updateNoticeShowState(params).then(res => {
                    if (res.data.code == 200) {
                        row.noticeShow = noticeShow
                        this.$message.success(res.data.message)
                    } else {
                        this.$message.success(res.data.message)
                    }
                }).catch(err => {
                    this.$message.error('请求失败')
                })
            }).catch(err =>{})
        },
        
        // row点击  进入编辑页
        rowNoticeClick(row, column) {
            if (column.label != '内容') return
            localStorage.setItem('noticeId', row.id)
            setTimeout(() => {
                this.$router.push('/Notice')
            }, 100);
        },

        // 公告查询条件下拉框
        currentNotice() {
            this.initNoticeData()
        },

        // 公告搜索框
        handleNoticeSearch() {
            this.initNoticeData()
        },

        // 上一页 or 下一页
        handleNoticePageChange(pageIndex) {
            this.notice.pageIndex = pageIndex
            this.initNoticeData()
        },

        // el-Tbale 时间格式
        dateFormat(row, column) {
            let date = row[column.property]
            if (date == undefined) return ''

            return moment(date).format("YYYY-MM-DD HH:mm:ss")
        },

        tableCellStyle(row, column) {
            if (row.column.label == '内容') {
                return {'cursor': 'pointer'}
            }
        },
    }
}
</script>

<style scoped lang="scss">
    .handle-input {
        width: 260px;
        display: inline-block;
        margin-right: 10px;
    }
    .cont {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
</style>
